import React from 'react';
import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@roger/ui-components';
import { Loader2 } from 'lucide-react';
import type { VisitTypeOption } from '../../services/api/types.gen';

export interface ChangeVisitTypeDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  options: VisitTypeOption[];
  selectedVisitType: string;
  onSelectedVisitTypeChange: (visitTypeId: string) => void;
  isLoading: boolean;
  onConfirm: () => void;
}

/** Change-task-type dialog (ROG-3322). Options come from the backend alias list. */
export const ChangeVisitTypeDialog: React.FC<ChangeVisitTypeDialogProps> = ({
  open,
  onOpenChange,
  options,
  selectedVisitType,
  onSelectedVisitTypeChange,
  isLoading,
  onConfirm,
}) => (
  <Dialog
    open={open}
    onOpenChange={nextOpen => {
      if (!nextOpen && !isLoading) onOpenChange(false);
    }}
  >
    <DialogContent className='sm:max-w-lg'>
      <DialogHeader>
        <DialogTitle>Change Task Type</DialogTitle>
        <DialogDescription>
          Pick the correct name for this task. Everything charted so far is
          kept.
        </DialogDescription>
      </DialogHeader>
      <Select
        value={selectedVisitType}
        onValueChange={onSelectedVisitTypeChange}
        disabled={isLoading}
      >
        <SelectTrigger id='change-task-type' selectSize='default'>
          <SelectValue placeholder='Select a task type…' />
        </SelectTrigger>
        <SelectContent>
          {options.map(option => (
            <SelectItem key={option.id} value={option.id}>
              {option.display_name}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      <DialogFooter>
        <Button
          variant='outline'
          onClick={() => onOpenChange(false)}
          disabled={isLoading}
        >
          Cancel
        </Button>
        <Button onClick={onConfirm} disabled={!selectedVisitType || isLoading}>
          {isLoading ? (
            <>
              <Loader2 className='h-4 w-4 animate-spin' />
              Changing...
            </>
          ) : (
            'Change Type'
          )}
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);
